import type { ICellRendererParams } from 'ag-grid-community';
import type { Forecast, ForecastMetric } from '../../schema';

const STYLES: Record<ForecastMetric, { label: string; bg: string; text: string }> = {
  max: { label: 'Max', bg: 'bg-primary/15', text: 'text-primary' },
  modal: { label: 'Modal', bg: 'bg-secondary/15', text: 'text-secondary' },
};

export function MetricBadge(p: ICellRendererParams<Forecast, ForecastMetric>) {
  const metric = p.value;
  if (!metric) return null;
  const s = STYLES[metric];
  return (
    <span
      className={[
        'inline-flex w-fit shrink-0 items-center gap-1.5 self-center rounded-full px-2 py-[3px]',
        'text-[10px] font-black uppercase leading-none tracking-tight',
        s.bg,
        s.text,
      ].join(' ')}
    >
      {s.label}
    </span>
  );
}
